"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../constants");
/**
 * Prevents the element from collapsing if the input is "".
 */
const NARROW_NO_BREAK_SPACE = ' ';
const ErrorMessageElement = styled_1.default.div({
    color: constants_1.Color.RED,
    fontSize: constants_1.theme.font.size['6.5'],
    lineHeight: 1,
    paddingTop: 8,
    userSelect: 'none',
});
const ErrorMessage = ({ errorMessage, reserveSpace, }) => {
    if (!errorMessage && !reserveSpace) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ErrorMessageElement, { children: errorMessage ? errorMessage : NARROW_NO_BREAK_SPACE }));
};
exports.ErrorMessage = ErrorMessage;
